module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/something_went_wrong.f81b98b185e1481306c158c98055e173.svg";